var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRosLetter = function SvgRosLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M46 20.72V46H2V20.72l6.17 4.203 10.87 7.406a9.425 9.425 0 0 0 10.728-.116l10.063-7.125z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M39.83 2v23.088l-10.063 7.125a9.43 9.43 0 0 1-10.727.116L8.17 24.923V2zM18.286 31.815 9.632 40.47M30.34 31.807l8.663 8.663M2 20.72l6.17-6.17M46 20.72l-6.169-6.17M14.56 8.39h18.88M14.56 14.78h18.88M14.56 21.17h18.88"
  })));
};
export default SvgRosLetter;